module.exports = __webpack_public_path__ + "static/media/Tia.ba19bfe8.jpg";